import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const dashboardFormSchema = z.object({
  date: z.string(),
  type: z.string(),
});

export type DashboardForm = z.infer<typeof dashboardFormSchema>;

const dashboardFormDefaultValues: DashboardForm = {
  date: '',
  type: '',
};

export const useDashboardForm = () => {
  const form = useForm({
    defaultValues: dashboardFormDefaultValues,
    resolver: zodResolver(dashboardFormSchema),
    reValidateMode: 'onBlur',
  });

  return form;
};
